import { EditorialModule } from '../src/EditorialModule.tsx';
export default EditorialModule;
